var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center"},[_c('v-progress-linear',{attrs:{"color":"tvf_color accent-4","indeterminate":"","rounded":"","height":"6"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }